<div class="container">

  <!-- Breadcrumb -->
  <div class="dashboard_bred_crumb">
    <ul>
      <li>
        <img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt="">
      </li>
      <li>
        <a [routerLink]="['/profile/join-request']" routerLinkActive="active-link">Join Requests</a>
      </li>
    </ul>
  </div>

  <!-- Card Wrapper -->
  <div class="bg-white p-3" style="border-radius: 10px;">

    <!-- Tabs -->
    <div class="custom-tabs">
      <mat-button-toggle-group
        class="horizontal-toggle-buttons tabs-button-group"
        [value]="selectedTabStatus"
        exclusive
        style="width: 100%;"
        (change)="onTabChange($event.value, $event.source.selected?.index)"
      >
        <mat-button-toggle value="ALL">All</mat-button-toggle>
        <mat-button-toggle value="REGISTERED">Registered</mat-button-toggle>
        <mat-button-toggle value="PENDING">Pending</mat-button-toggle>
        <mat-button-toggle value="APPROVED">Approved</mat-button-toggle>
        <mat-button-toggle value="REJECTED">Rejected</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <!-- Table -->
    <div class="table-container">
      <table class="table custom-table mb-0">
        <thead>
          <tr>
            <th class="sno-col">S.No</th>
            <th class="first-name-col">First Name</th>
            <th class="last-name-col">Last Name</th>
            <th class="email-col">Email</th>
            <th class="phone-col">Phone</th>
            <th class="status-col">Status</th>


            <!-- <th class="membership-col" *ngIf="selectedTabStatus !== 'REGISTERED'">Membership No</th> -->
            <th class="membership-col">Membership No</th>
            <th class="action-col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of filteredUsers; let i = index">
            <td class="sno-col">{{ i + 1 }}</td>
            <td matTooltip="{{ user.first_name }}" class="text-truncate first-name-col">
              {{ user.first_name || '-' }}
            </td>
            <td matTooltip="{{ user.last_name }}" class="text-truncate last-name-col">
              {{ user.last_name || '-' }}
            </td>
            <td matTooltip="{{ user.email }}" class="text-truncate email-col">
              {{ user.email || '-' }}
            </td>
            <td matTooltip="{{ user.phone }}" class="text-truncate phone-col">
              {{ user.phone || '-' }}
            </td>
             <td class="text-truncate status-col">
              {{ user.status || '-' }}
            </td>
            <td matTooltip="{{ user.membership_number }}" class="text-truncate membership-col">
              {{ user.membership_number || '-' }}
            </td>
            <!-- <td matTooltip="{{ user.membership_number }}" *ngIf="selectedTabStatus !== 'REGISTERED'" class="text-truncate membership-col">
              {{ user.membership_number || '-' }}
            </td> -->
            <!-- <td matTooltip="{{ user.membership_number }}" class="text-truncate membership-col">
              {{ !user.is_registered ? (user.membership_number || '') : '' }}
            </td> -->

            <!-- Actions column with 3-dot menu -->
            <td class="action-col">
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="Actions"
                class="action-menu-btn"
              >
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  *ngIf="user.status === 'PENDING' || user.status === 'REJECTED'"
                  (click)="updatestatus(user, 'APPROVED')"
                >
                  <mat-icon color="primary">check_circle</mat-icon>
                  <span>Approve</span>
                </button>

                <button
                  mat-menu-item
                  *ngIf="user.status === 'PENDING' || user.status === 'APPROVED'"
                  (click)="updatestatus(user, 'REJECTED')"
                >
                  <mat-icon color="warn">cancel</mat-icon>
                  <span>Reject</span>
                </button>
              </mat-menu>
            </td>
          </tr>

          <!-- No Data Message -->
          <tr *ngIf="!loading && filteredUsers.length === 0">
            <td colspan="7" class="text-center py-3">No records found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="text-center p-3">
      Loading Members...
    </div>

    <!-- Mat Paginator -->
    <div class="custom-paginator">
      <mat-paginator
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 20, 50]"
        showFirstLastButtons="false"
        (page)="onPageChange($event)"
      ></mat-paginator>
    </div>

  </div>
</div>
